export { TASK, SAGA_ACTION, noop, is, deferred, arrayOfDeffered, createMockTask } from './internal/utils';
export { asEffect } from './internal/io';
export { CHANNEL_END } from './internal/proc';


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/redux-saga/es/utils.js
// module id = 1104
// module chunks = 0